import { Role, RoleDetail } from '@/entities/role';

export function intoEditable(data: RoleDetail): Role {
  return {
    ...data.data,
    users: data.data.users.map(user => user.id),
  };
}
